export default "__VITE_ASSET__Bp42e$96__"